(function () {
  'use strict';

  var initialized = false;

  function openWishlistDrawer(swat) {
    if (swat && swat.ui && typeof swat.ui.open === 'function') {
      swat.ui.open();
      return;
    }
  }

  function initHeaderIcon(swat) {
    if (initialized) return;
    initialized = true;

    var btn = document.getElementById('swym-header-wishlist-btn');
    if (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openWishlistDrawer(swat);
      });
    }

    if (window.SwymWishlistHelpers) {
      window.SwymWishlistHelpers.updateHeaderCount(swat);
    }
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initHeaderIcon);
})();
